const locale = {
    placeholder: 'Izvēlieties laiku',
    rangePlaceholder: ['Sākuma laiks', 'Beigu laiks'],
};
export default locale;
